var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLesson6Eye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.168 9.206C-6.066 24.076 1.972 35.52 12.34 47.428c5.346 6.14 10.158 12.594 10.212 18.102 1.294 6.652 17.32-9.072 29.666-24.798 10.356-13.194 18.126-26.388 12.426-26.364-5.424 1.02-12.706-2.432-19.784-6.466C37.362 3.628 30.138-.002 23.142 0 17.336 0 11.686 2.5 6.168 9.206",
    id: "a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "13.8309064%",
    y1: "53.9317738%",
    x2: "77.8105475%",
    y2: "41.8757664%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE26E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AF38",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.274.002C37.8.104 25.232 8.11 14.684 20.934 4.084 33.816-1.34 47.744.284 56.044 1.318 61.336 8.516 67.07 13.9 66.926c8.472-.232 20.922-8.21 31.386-20.93 10.5-12.764 15.92-26.552 14.444-34.876C58.796 5.852 51.75 0 46.366 0c-.03 0-.062 0-.092.002",
    id: "d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "22.8374118%",
    y1: "71.2891051%",
    x2: "86.2312615%",
    y2: "21.6025914%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE26E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AF38",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.066 22.342C7.496 30.328 2.85 38.806.424 46.482c-1.084 3.436-.054 6.984 2.7 9.31 2.756 2.324 6.436 2.75 9.65 1.114 8.71-4.436 17.31-13.128 21.402-18.102 10.5-12.764 15.92-26.552 14.444-34.876C48.388 2.62 47.782 1.28 46.918 0c-9.892 1.534-22.446 9.694-32.852 22.342",
    id: "g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.1863993%",
    y1: "51.145884%",
    x2: "75.652549%",
    y2: "49.3045088%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E47C1D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AF38",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.716 21.852C10.114 29.148 6.012 36.074.944 38.256c-10.384 6.928 68.466 30.378 63.58 18.91-3.044-4.596-2.676-12.63-1.686-20.704 1.914-15.648 2.19-29.622-16.186-35.086C43.484.434 40.642 0 38.07 0 25.63.002 19.51 10.13 13.716 21.852",
    id: "j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.309458%",
    y1: "35.8312511%",
    x2: "74.9802759%",
    y2: "83.5773818%",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE26E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AF38",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.603 3.732C1.113 6.732-1.4 15.574.82 20.47c3.492 7.704 15.69 16.066 31.494 20.766 15.86 4.718 30.7 4.366 37.822-.216 4.532-2.918 7.216-11.746 5.066-16.684C71.825 16.58 59.561 8.12 43.627 3.382 35.939 1.096 28.493 0 22.047 0 15.069 0 9.265 1.286 5.603 3.732",
    id: "m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "22.5379292%",
    y1: "39.8211178%",
    x2: "86.5991475%",
    y2: "63.5750116%",
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE26E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AF38",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.98.236C4.384.568 1.504 2.89.422 6.326-.66 9.76.37 13.308 3.13 15.632c7.47 6.294 18.834 10.838 25.014 12.676 15.86 4.718 30.7 4.366 37.822-.216 1.118-.72 2.122-1.798 2.97-3.088C63.69 16.5 51.29 8.112 35.572 3.438 27.74 1.108 20.092 0 13.268 0 11.442 0 9.676.08 7.98.236",
    id: "p"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.6966686%",
    y1: "38.9008142%",
    x2: "57.3241036%",
    y2: "58.8268913%",
    id: "q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E47C1D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AF38",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.798.086c-22.92 1.32-41.086 23.348-47.216 36.61-4.956 10.722-5.694 16.068 3.778 25.296 23.968 23.354 71.505 25.768 97.083 4.458 12.37-10.306 9.292-22.394 2.104-34.64C96.53 14.748 76.48 0 53.8 0c-.996 0-1.998.028-3.002.086",
    id: "s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.710765%",
    y1: "65.320732%",
    x2: "50.9131223%",
    y2: "25.4327985%",
    id: "t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE2EF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 39.728c0 21.88 16.178 39.728 36.014 39.728 19.834 0 36.012-17.848 36.012-39.728C72.026 17.848 55.848 0 36.014 0 16.178 0 0 17.848 0 39.728",
    id: "v"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.5084128%",
    y1: "0.493413462%",
    x2: "50.204922%",
    y2: "70.6379166%",
    id: "w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A51C05",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C34B14",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M0 0L137.584597 0 137.584597 51.8522482 0 51.8522482z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.86 2.296C62.818 12.202 41.982 13.12 24.322 8.464 17.562 6.68 4.026-.92 0 2.274c19.308 20.06 62.444 23.802 88.956 6.976 3.372-2.14 5.636-6.41 2.274-8.504C90.408.234 89.4 0 88.272 0 86.08 0 83.44.88 80.86 2.296",
    id: "A"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00120900434%",
    y1: "50.000979%",
    x2: "99.9998974%",
    y2: "50.000979%",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE2EF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E47C1E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.083 3.868c2.01-2.442 5.652-2.8 8.1-.796l3.146 2.576c2.446 2.004 2.804 5.64.796 8.082-2.008 2.44-5.652 2.798-8.1.794L3.88 11.95c-2.448-2.004-2.806-5.64-.798-8.082",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(108.104 102.977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.462 4.998a3.965 3.965 0 00.55 5.576l4.996 4.092a3.985 3.985 0 005.588-.55 3.957 3.957 0 00-.548-5.574L10.05 4.45a3.978 3.978 0 00-5.588.548m-2.76-2.26C4.33-.456 9.114-.924 12.314 1.696l4.998 4.092c3.2 2.622 3.673 7.394 1.044 10.588-2.632 3.198-7.408 3.666-10.612 1.042l-4.998-4.092C-.458 10.702-.928 5.936 1.702 2.738",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(108.104 102.977)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(115.73 106.322)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.168 9.206C-6.066 24.076 1.972 35.52 12.34 47.428c5.346 6.14 10.158 12.594 10.212 18.102 1.294 6.652 17.32-9.072 29.666-24.798 10.356-13.194 18.126-26.388 12.426-26.364-5.424 1.02-12.706-2.432-19.784-6.466C37.362 3.628 30.138-.002 23.142 0 17.336 0 11.686 2.5 6.168 9.206",
    fill: "url(#b)",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.957 10.983c1.312-1.594 2.63-2.948 3.958-4.09.648.218 1.288.462 1.91.736-1.87 5.794-2.438 13.73 9.04 27.002l9.508 10.992s-1.326 9.588 4.108 16.358c-6.418 5.966-11.44 8.93-12.14 5.328-.054-5.508-4.866-11.962-10.212-18.102C3.763 37.3-4.277 25.853 7.957 10.983",
    fill: "#F8AF38",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(113.94 104.544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.573 3.623c-5.864-.496-11.588 1.626-17.236 8.49C3.655 19.02 2.66 25.061 4.279 30.717c1.68 5.872 6.15 11.53 11.192 17.322 2.726 3.13 5.322 6.352 7.268 9.53 1.976 3.234 3.278 6.43 3.378 9.46.036.044.1.056.188.038 4.172-.808 14.212-10.878 23.28-21.902 9.07-11.024 17.014-22.812 16.996-27.052-.002-.088-.024-.148-.074-.174-3 .492-6.396-.158-9.958-1.464-3.504-1.284-7.178-3.196-10.788-5.254-6.674-3.804-13.104-7.082-19.188-7.598M6.579 9.853C13.097 1.931 19.859-.509 26.869.085c6.788.576 13.624 4.04 20.67 8.056 3.468 1.976 6.974 3.806 10.236 5.002 3.1 1.136 5.966 1.702 8.33 1.256.108-.02.216-.03.322-.03 2.556-.012 3.708 1.338 3.718 3.732.022 5.096-8.298 17.774-17.8 29.324C42.843 58.973 32 69.587 26.985 70.56c-2.354.456-3.906-.408-4.394-2.91a1.842 1.842 0 01-.032-.374c-.038-2.386-1.148-5.062-2.858-7.856-1.81-2.958-4.292-6.034-6.912-9.042C7.463 44.261 2.73 38.241.859 31.695c-1.936-6.762-.832-13.878 5.72-21.842",
    fill: "#E47C1E",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(113.94 104.544)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(138.255 120.014)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.274.002C37.8.104 25.232 8.11 14.684 20.934 4.084 33.816-1.34 47.744.284 56.044 1.318 61.336 8.516 67.07 13.9 66.926c8.472-.232 20.922-8.21 31.386-20.93 10.5-12.764 15.92-26.552 14.444-34.876C58.796 5.852 51.75 0 46.366 0c-.03 0-.062 0-.092.002",
    fill: "url(#e)",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.806 180.684c-5.736 3.908-11.234 6.136-15.652 6.256-5.384.146-12.582-5.59-13.616-10.88-1.144-5.854.868-16.748 7.518-26.19-2.85 6.732 4.364 16.656 14.404 20.34 8.804 4.458 5.134 7.616 7.346 10.474",
    fill: "#F8AF38",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(149.364 127.206)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.066 22.342C7.496 30.328 2.85 38.806.424 46.482c-1.084 3.436-.054 6.984 2.7 9.31 2.756 2.324 6.436 2.75 9.65 1.114 8.71-4.436 17.31-13.128 21.402-18.102 10.5-12.764 15.92-26.552 14.444-34.876C48.388 2.62 47.782 1.28 46.918 0c-9.892 1.534-22.446 9.694-32.852 22.342",
    fill: "url(#h)",
    mask: "url(#i)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.382 32.066c.912.324 1.79.794 2.6 1.416a9.472 9.472 0 011.742 13.302c-3.2 4.154-9.17 4.934-13.334 1.74a9.445 9.445 0 01-3.55-5.776c3.068-3.242 7.556-7.504 12.542-10.682",
    fill: "#F49826",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(105.423 103.361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.878 34.227l-.31-.16c-2.132 1.422-4.158 3.032-6 4.648a82.146 82.146 0 00-4.772 4.56 7.79 7.79 0 00.796 1.762 7.751 7.751 0 001.884 2.08 7.721 7.721 0 005.714 1.53 7.705 7.705 0 005.042-2.84c.034-.052.072-.104.112-.154l.006.004A7.687 7.687 0 0079.848 40a7.68 7.68 0 00-2.846-5.03 1.35 1.35 0 01-.152-.112l.002-.004a7.84 7.84 0 00-.974-.626m.222-3.788c.516.19 1.014.414 1.492.674.502.274.994.594 1.474.962l.044.034.004-.004.08.068a11.228 11.228 0 014.186 7.37 11.21 11.21 0 01-2.246 8.322l-.034.044.004.004-.068.08a11.276 11.276 0 01-7.388 4.178 11.271 11.271 0 01-8.342-2.242 11.218 11.218 0 01-4.212-6.858 1.772 1.772 0 01.45-1.538l-.004-.004a86.41 86.41 0 015.674-5.48c2.194-1.924 4.638-3.842 7.208-5.48a1.777 1.777 0 011.678-.13",
    fill: "#E47C1E",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(105.423 103.361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.545 75.47c.532 2.276-2.3 2.948-3.146.026-1.256-4.328.022-8.77 2.724-14.124 2.602-5.152 6.436-10.504 10.522-15.47 4.174-5.072 8.86-10.098 13.552-13.758 4.916-3.834 9.322-6.176 13.734-5.12 2.754.66 3.316 3.254.176 3.066-3.45-.208-7.512 1.566-11.714 4.844-4.426 3.452-8.934 8.3-12.988 13.226-3.96 4.814-7.65 9.952-10.102 14.808-2.35 4.656-3.57 9.024-2.758 12.502",
    fill: "#E47C1E",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(105.423 103.361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.365 32.324c5.606-5.528 16.56-13.798 24.762-13.898 2.26-.028 4.966 1.262 7.242 3.142 2.274 1.878 4.044 4.292 4.44 6.516.69 3.89-.296 9.172-2.728 15.046-2.42 5.842-6.272 12.224-11.344 18.39-5.054 6.142-10.556 11.142-15.81 14.646-5.29 3.526-10.282 5.53-14.242 5.638-2.262.062-4.988-1.178-7.29-3.018-2.294-1.832-4.098-4.208-4.53-6.428-.942-4.808 1.272-13.426 3.292-17.782.982-2.118-.034-4.244-2.202-.98-3.434 5.174-5.804 13.238-4.59 19.442.598 3.066 2.906 6.198 5.808 8.518 2.904 2.32 6.478 3.882 9.604 3.796 4.634-.124 10.282-2.342 16.124-6.238 5.558-3.706 11.336-8.942 16.596-15.334 5.278-6.416 9.308-13.114 11.868-19.294 2.69-6.496 3.756-12.47 2.948-17.024-.544-3.074-2.806-6.256-5.678-8.628-2.866-2.368-6.418-3.99-9.55-3.953-9.746.12-20.556 8.62-26.932 15.387-2.41 2.556-.178 4.412 2.212 2.056m-7.756 3.57c1.138-1.356 2.416-1.404 3.082-.774.624.59.712 1.78-.354 3.052-1.08 1.286-2.28 1.402-2.97.88-.726-.548-.89-1.806.242-3.158",
    fill: "#E47C1E",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(105.423 103.361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.073 14.752c-5.278-1.64-7.388-8.348 2.686-8.056 4.188.122 14.886 3.368 22.168 9.616 6.092 5.226.81 10.22-5.288 6.666-5.752-3.354-12.782-6.118-19.566-8.226",
    fill: "#FFDC97",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(105.423 103.361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.03 2.019c3.035.902 4.777 4.116 3.873 7.144l-1.162 3.89c-.906 3.026-4.126 4.764-7.16 3.862-3.034-.904-4.776-4.116-3.872-7.144l1.162-3.89c.906-3.026 4.126-4.764 7.16-3.862",
    fill: "#F8AF38",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(105.423 103.361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.52 3.726A3.983 3.983 0 005.58 6.39l-1.845 6.182a3.97 3.97 0 007.61 2.264l1.846-6.182a3.963 3.963 0 00-2.67-4.928M11.54.312c3.968 1.182 6.254 5.4 5.072 9.36l-1.848 6.18c-1.182 3.96-5.41 6.24-9.378 5.06C1.41 19.73-.871 15.518.313 11.554L2.16 5.372c1.184-3.964 5.408-6.24 9.38-5.06",
    fill: "#E47C1E",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(105.423 103.361)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(65.926 117.22)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.716 21.852C10.114 29.148 6.012 36.074.944 38.256c-10.384 6.928 68.466 30.378 63.58 18.91-3.044-4.596-2.676-12.63-1.686-20.704 1.914-15.648 2.19-29.622-16.186-35.086C43.484.434 40.642 0 38.07 0 25.63.002 19.51 10.13 13.716 21.852",
    fill: "url(#k)",
    mask: "url(#l)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.587 132.869c-1.812-5.586-5.99-10.03-14.52-12.568-8.582-2.552-14.55-1.128-19.15 2.55-4.776 3.82-8.274 10.122-11.674 17.002-1.838 3.72-3.81 7.358-5.994 10.378-2.222 3.07-4.67 5.506-7.432 6.77-.028.05-.014.112.036.188 2.362 3.524 15.556 8.86 29.256 12.934 13.698 4.074 27.668 6.818 31.578 5.158.082-.034.13-.08.134-.136-1.618-2.568-2.33-5.942-2.504-9.726-.17-3.72.174-7.842.678-11.958.932-7.612 1.472-14.796-.408-20.592m-13.5-15.98c9.846 2.928 14.718 8.204 16.884 14.882 2.096 6.468 1.542 14.096.56 22.132-.484 3.956-.818 7.89-.66 11.354.152 3.292.738 6.146 2.064 8.148.062.092.112.188.154.286 1 2.346.198 3.928-2.008 4.864-4.704 1.996-19.64-.75-33.992-5.018-14.352-4.27-28.358-10.132-31.198-14.37-1.334-1.99-1.136-3.752.988-5.168.106-.072.218-.13.332-.176 2.19-.96 4.234-3.016 6.152-5.67 2.034-2.812 3.914-6.286 5.68-9.86 3.59-7.266 7.322-13.952 12.644-18.208 5.5-4.398 12.504-6.14 22.4-3.196",
    fill: "#E47C1E",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(57.48 153.608)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.603 3.732C1.113 6.732-1.4 15.574.82 20.47c3.492 7.704 15.69 16.066 31.494 20.766 15.86 4.718 30.7 4.366 37.822-.216 4.532-2.918 7.216-11.746 5.066-16.684C71.825 16.58 59.561 8.12 43.627 3.382 35.939 1.096 28.493 0 22.047 0 15.069 0 9.265 1.286 5.603 3.732",
    fill: "url(#n)",
    mask: "url(#o)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(61.65 166.536)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#p"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.98.236C4.384.568 1.504 2.89.422 6.326-.66 9.76.37 13.308 3.13 15.632c7.47 6.294 18.834 10.838 25.014 12.676 15.86 4.718 30.7 4.366 37.822-.216 1.118-.72 2.122-1.798 2.97-3.088C63.69 16.5 51.29 8.112 35.572 3.438 27.74 1.108 20.092 0 13.268 0 11.442 0 9.676.08 7.98.236",
    fill: "url(#q)",
    mask: "url(#r)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.291 94.774a9.48 9.48 0 01-.302 2.938c-1.338 5.066-6.54 8.092-11.618 6.756-5.078-1.336-8.11-6.526-6.77-11.592a9.453 9.453 0 013.962-5.504c4.184 1.568 9.86 4.046 14.728 7.402",
    fill: "#F49826",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(55.706 85.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.486 96.068l.028-.346c-2.138-1.412-4.412-2.652-6.618-3.72a81.963 81.963 0 00-6.062-2.624 7.776 7.776 0 00-1.32 1.414 7.727 7.727 0 00-1.194 2.538 7.68 7.68 0 00.8 5.85 7.704 7.704 0 004.576 3.538c.062.01.124.026.186.044l-.002.004a7.723 7.723 0 005.808-.81 7.684 7.684 0 003.546-4.566c.012-.062.026-.124.046-.184h.004c.096-.372.162-.752.202-1.138m3.586-1.262c.024.548.01 1.094-.044 1.634a11.48 11.48 0 01-.318 1.726l-.014.054.004.002-.032.1a11.234 11.234 0 01-5.19 6.706 11.27 11.27 0 01-8.56 1.156l-.054-.014-.002.006-.1-.034a11.259 11.259 0 01-6.722-5.178 11.203 11.203 0 01-1.158-8.54 11.18 11.18 0 011.744-3.696 11.307 11.307 0 012.962-2.836 1.778 1.778 0 011.596-.18l.002-.004a86.785 86.785 0 017.262 3.096c2.628 1.274 5.346 2.778 7.856 4.508.51.35.778.918.768 1.494",
    fill: "#E47C1E",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(55.706 85.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.402 85.974C8.504 87.346 6.788 85 9.16 83.09c3.514-2.832 8.114-3.376 14.106-2.962 5.768.398 12.198 1.852 18.372 3.688 6.304 1.874 12.762 4.24 17.96 7.138 5.448 3.038 9.318 6.184 10.05 10.652.456 2.788-1.724 4.31-2.764 1.348-1.146-3.254-4.356-6.302-9.012-8.898-4.904-2.736-11.13-5.006-17.254-6.826-5.98-1.78-12.158-3.184-17.596-3.56-5.212-.36-9.72.21-12.62 2.304",
    fill: "#E47C1E",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(55.706 85.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.448 44.376c2.606-4.146 6.266-6.692 8.934-5.022 2.67 1.67 1.978 6.024-.628 10.17-2.608 4.148-6.142 6.518-8.812 4.848-2.67-1.672-2.1-5.85.506-9.996",
    fill: "#FFF",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(55.706 85.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.915 75.542c7.278 3.016 19.162 9.89 22.432 17.396.9 2.068.756 5.058-.1 7.878-.854 2.818-2.4 5.384-4.302 6.606-3.328 2.142-8.59 3.282-14.96 3.318-6.338.036-13.726-1.036-21.388-3.314-7.634-2.27-14.382-5.396-19.656-8.872-5.308-3.5-9.092-7.316-10.724-10.918-.934-2.058-.844-5.044-.036-7.872.806-2.82 2.302-5.4 4.186-6.658 4.078-2.728 12.902-4.028 17.708-3.858 2.338.084 3.908-1.674.054-2.404-6.11-1.156-14.482-.212-19.744 3.306-2.602 1.738-4.604 5.072-5.622 8.64-1.022 3.57-1.08 7.464.21 10.306 1.908 4.212 6.146 8.552 12.006 12.416 5.578 3.678 12.656 6.964 20.598 9.328 7.974 2.37 15.724 3.486 22.424 3.446 7.046-.04 12.98-1.372 16.876-3.88 2.628-1.69 4.694-5.002 5.774-8.562 1.08-3.556 1.202-7.45-.046-10.318-3.884-8.918-15.926-15.57-24.646-18.816-3.296-1.226-4.146 1.546-1.044 2.832m-6.302-5.752c1.692.522 2.234 1.678 1.908 2.536-.304.802-1.368 1.344-2.958.854-1.604-.494-2.178-1.552-1.964-2.39.226-.88 1.326-1.518 3.014-1",
    fill: "#E47C1E",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(55.706 85.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.747 46.391c-.528-5.49 4.852-10.028 8.484-.648 1.51 3.898 2.652 14.998-.302 24.114-2.47 7.628-9.13 4.704-8.208-2.282.872-6.59.706-14.128.026-21.184",
    fill: "#FFDC97",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(55.706 85.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.589 70.526c4.05-.17 7.554 1.052 7.76 3.518.206 2.464-3.034 3.958-7.084 4.128-4.05.168-7.376-1.052-7.582-3.516-.208-2.464 2.856-3.96 6.906-4.13",
    fill: "#FFF",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(55.706 85.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.755 11.416c-5.12.138-5.156 4.442.95 5.056 3.646.368 8.618 2.84 11.088 5.376 3.064 3.146 6.336 1.858 4.494-1.75-2.882-5.65-9.386-8.874-16.532-8.682M114.12.584c-6.69 1.552-4.574 4.912 1.346 4.762 4.952-.126 12.806 1.962 17.058 4.82 4.122 2.772 5.874.362 3.198-2.82-4.776-5.68-13.274-8.694-21.602-6.762",
    fill: "#E47C1E",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(55.706 85.713)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(1.601 3.6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.798.086c-22.92 1.32-41.086 23.348-47.216 36.61-4.956 10.722-5.694 16.068 3.778 25.296 23.968 23.354 71.505 25.768 97.083 4.458 12.37-10.306 9.292-22.394 2.104-34.64C96.53 14.748 76.48 0 53.8 0c-.996 0-1.998.028-3.002.086",
    fill: "url(#t)",
    mask: "url(#u)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(22.33 4.412)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#v"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 39.728c0 21.88 16.178 39.728 36.014 39.728 19.834 0 36.012-17.848 36.012-39.728C72.026 17.848 55.848 0 36.014 0 16.178 0 0 17.848 0 39.728",
    fill: "url(#w)",
    mask: "url(#x)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.82 79.585c14.948 0 27.14-7.812 27.14-17.39 0-9.58-12.192-17.392-27.14-17.392s-27.14 7.812-27.14 17.392c0 9.578 12.192 17.39 27.14 17.39",
    fill: "#DF8458",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.343 67.669c11.748 0 21.328-10.57 21.328-23.528 0-12.96-9.58-23.53-21.328-23.53S37.015 31.18 37.015 44.14c0 12.958 9.58 23.528 21.328 23.528",
    fill: "#930E03",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#y"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.874 48.899c10.67.496 24.466-5.052 23.678-19.968-5.734 2.028-12.806 2.188-18.004-.724C76.568-20.54 16.018-1.298.152 49.295c-.678 2.16.98 4.178 3.398.604 32.436-47.935 81.928-41.145 110.324-1",
    fill: "#930E03",
    mask: "url(#z)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.88 69.958C69.806 82.628 42.162 80.598 22.438 71c-10.876-5.292-21.396.472-12.854 12.446 21.116 29.608 74.074 30.548 94.146-2.598 6.264-10.346.578-17.164-10.85-10.89",
    fill: "#CCE1EB",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(12.02 67.662)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "C",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.86 2.296C62.818 12.202 41.982 13.12 24.322 8.464 17.562 6.68 4.026-.92 0 2.274c19.308 20.06 62.444 23.802 88.956 6.976 3.372-2.14 5.636-6.41 2.274-8.504C90.408.234 89.4 0 88.272 0 86.08 0 83.44.88 80.86 2.296",
    fill: "url(#B)",
    mask: "url(#C)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.93 36.826c11.36-.168 23.011-2.808 33.663-8.658 3.958-2.174 10.426-4.358 14.104-.498 3.59 3.768 1.36 9.968-.95 13.782-3.712 6.132-8.518 11.14-14.03 15.052-9.698 6.886-21.582 10.36-33.538 10.598-11.946.236-23.984-2.754-34.008-8.796-5.104-3.076-11.856-8.63-15.76-14.564-6.95-10.568-1.276-19.818 11.474-15.946 15.268 4.634 19.406 9.32 39.044 9.03m35.322-5.646c-11.166 6.13-23.378 8.9-35.282 9.076-20.364.3-24.848-4.186-40.234-9.198-9.33-3.04-12.452 2.974-7.706 10.434 3.538 5.562 10.268 11.064 14.922 13.868 9.472 5.71 20.856 8.536 32.16 8.312 11.292-.224 22.492-3.49 31.612-9.964 5.132-3.644 9.608-8.312 13.072-14.032 1.362-2.248 3.682-7.254 1.408-9.64-2.322-2.436-7.634-.128-9.952 1.144",
    fill: "#C89A6C",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(3.458 40.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.475 50.283c4.51 1.482 5.358 6.8-2.09 5.958-9.556-1.078-20.004-5.642-25.628-15.064-2.568-4.302.822-5.426 4.45-2.962 4.608 3.13 12.392 8.492 23.268 12.068M31.49 5.582C36.75.552 42.94-1.79 46.18 1.578c3.238 3.37.66 9.39-4.598 14.418-5.26 5.03-11.21 7.164-14.446 3.794-3.238-3.368-.902-9.18 4.356-14.208M67.118 25.37c3.54-2.192 5.742-4.984 8.574-8.846 1.97-2.688 4.586-1.574 4.806 2.156.264 4.426-2.296 12.416-10.34 13.118-6.124.534-6.626-4.208-3.04-6.428",
    fill: "#FFF",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(3.458 40.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.87 101.163c0 8.03-6.525 14.538-14.573 14.538-8.046 0-14.688-6.51-14.57-14.538C1.84 93.411 8.06 83.16 12.743 76.52c2.514-3.566 4.986-4.012 7.416-.4 1.444 2.146 10.71 18.218 10.71 25.044",
    fill: "#CCE1EB",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(3.458 40.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.382 110.226a12.766 12.766 0 003.762-9.062c0-2.234-1.172-5.724-2.726-9.358-2.804-6.562-6.792-13.402-7.688-14.734-.828-1.23-1.524-1.78-2.106-1.73-.688.058-1.518.81-2.472 2.164-2.65 3.756-5.794 8.676-7.992 13.594-1.58 3.536-2.67 7.054-2.714 10.084l.004.188c0 3.456 1.424 6.58 3.712 8.852a12.947 12.947 0 008.94 3.76l.196-.004c3.548 0 6.76-1.436 9.084-3.754m7.212-9.062c0 4.488-1.824 8.554-4.772 11.496a16.269 16.269 0 01-11.524 4.762l-.236-.008a16.39 16.39 0 01-11.326-4.758C1.816 109.758 0 105.776 0 101.372l.008-.228C.06 97.588 1.27 93.618 3.02 89.7c2.314-5.176 5.574-10.286 8.314-14.17 1.56-2.21 3.222-3.464 5.006-3.618 1.89-.16 3.646.87 5.248 3.252.94 1.396 5.104 8.53 7.998 15.296 1.716 4.014 3.008 7.96 3.008 10.704",
    fill: "#C89A6C",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(3.458 40.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.896 92.249c.422-3.302-1.922-6.414-5.33-.91-1.418 2.288-3.67 7.868-1.768 13.31 1.59 4.554 7.202 2.904 6.72-1.234-.408-3.492-.286-5.964.378-11.166",
    fill: "#FFF",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(3.458 40.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.535 98.668c.712-2.492 3.338-1.93 3.698 1.022.326 2.656-.632 7.752-5.736 10.792-4.15 2.47-7.38-.402-4.142-3.034 2.418-1.966 4.984-4.596 6.18-8.78M6.359 46.397s11.296 18.467 3.538 31.219l8.17-5.502 8.736 12.406c-3.432-13.236-.274-20.656 14.956-18.336l-14.84-5.103-20.56-14.684z",
    fill: "#C89A6C",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(3.458 40.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41 44.59c-3.324 3.282-7.076 4.732-8.38 3.238-1.304-1.492.334-5.364 3.658-8.644 3.324-3.282 7.076-4.732 8.38-3.238 1.304 1.492-.334 5.362-3.658 8.644",
    fill: "#FFF",
    transform: "translate(-250 -1196) translate(25 1171) translate(225 25) translate(3.458 40.283)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson6Eye);
export default __webpack_public_path__ + "static/media/lesson6-eye.ace797f4461afeb96e830704ef058cc7.svg";
export { ForwardRef as ReactComponent };